export const routes: Record<string, string> = {
  accessToken: "/api/rest/oauth2/token/client_credentials",
  login: "/api/rest/login",
  initialize: "/api/rest/user/initialize",
  logout: "/api/rest/logout",
  register: "/api/rest/register",
  confirm: "/api/rest/confirm",
  resendEmail: "/api/rest/confirm/resend",
  reset: "/api/rest/reset",
  forgot: "/api/rest/forgotten",
  ageVerify: "/api/rest/account/age-verify",
  products: "/api/rest/products",
  productLinks: "/api/rest/allproductlinks/ids",
  categoryLinks: "/api/rest/allcategorylinks/ids",
  productSlug: "/api/rest/products/slug",
  productById: "/api/rest/products",
  bestSellers: "/api/rest/bestsellers/limit",
  homepage: "/api/rest/homepage",
  cart: "/api/rest/cart",
  search: "/api/rest/products/search",
  giftSearch: "/api/rest/gift-search",
  category: "/api/rest/categories",
  categoriesAll: "/api/rest/categories/all",
  categorySlug: "/api/rest/categories/slug",
  categoryById: "/api/rest/categories",
  specialCategory: "/api/rest/special-categories",
  productsByCategory: "/api/rest/products/category",
  productsByManufacturer: "/api/rest/products/manufacturer",
  giftSettings: "/api/rest/gift/settings",
  giftAdd: "/api/rest/gift/add",
  giftEdit: "/api/rest/gift/edit",
  account: "/api/rest/account",
  accountDelete: "/api/rest/account/delete",
  transactions: "/api/rest/account/transactions",
  language: "/api/rest/languages",
  wishlist: "/api/rest/wishlist",
  orderHistory: "/api/rest/customerorders",
  subscribeNewsletter: "/api/rest/newsletter/subscribe",
  unsubscribeNewsletter: "/api/rest/newsletter/unsubscribe",
  changePassword: "/api/rest/account/password",
  addCoupon: "/api/rest/coupon",
  addGiftCode: "/api/rest/offerzcoupon",
  addresses: "/api/rest/account/address",
  country: "/api/rest/countries",
  paymentMethod: "/api/rest/paymentmethods",
  existingPaymentAddress: "/api/rest/paymentaddress/existing",
  paymentAddress: "/api/rest/paymentaddress",
  voucherWallet: "/api/rest/account/voucherwallet",
  voucherWalletGifts: "/api/rest/account/voucherwallet/search/gift=1",
  voucherBarcode: "/api/rest/account/voucherwallet-redeem-barcode",
  voucherInformation: "/api/rest/account/voucherwallet-information",
  esim: "/api/rest/account/voucherwallet/partial-esim",
  pdfLink: "/api/rest/account/voucherwallet-render-print-pdf",
  voucherEsim: "/api/rest/account/voucherwallet/esim",
  esimDownload: "/api/rest/esim/download_install_data",
  esimDataPlan: "/api/rest/esim/data_plan",
  esimPlans: "/api/rest/esim/manage_plans",
  esimTopup: "/api/rest/esim/topup",
  markRedeemed: "/api/rest/account/voucherwallet-mark-redeemed/uuid",
  redeemVoucher: "/api/rest/account/redeem-offerz-voucher",
  oacs: "/api/rest/oacs",
  tokenLogin: "/api/rest/tokenlogin",
  orderVouchers: "/api/rest/account/voucherwallet/order",
  loyaltyStatus: "/api/rest/loyalty/loyalty",
  earningRules: "/api/rest/loyalty/earning_rules",
  loyaltyTransactions: "/api/rest/loyalty/transactions/limit",
  slotMachine: "/api/rest/loyalty/slot_machine",
  rewards: "/api/rest/loyalty/rewards",
  activateRewards: "/api/rest/loyalty/activate_reedem_get_reward",
  stampCards: "/api/rest/loyalty/stamp_cards",
  enrollClaimStampCards: "/api/rest/loyalty/enroll_claim_get_competition",
  scratchcard: "/api/rest/loyalty/scratchcards",
  placeOrder: "/api/rest/place_order",
  placeTransaction: "/api/rest/sdk_transaction",
  failMessage: "/api/rest/fail_message",
  aliasPaymentMethod: "/api/rest/aliaspaymentmethods",
  information: "/api/rest/information",
  exportVouchers: "/api/rest/orderfile",
  renderPdf: "/api/rest/account/voucherwallet-render-pdf/uuid",
  resetPassword: "/api/rest/register/resetpasswordcode",
  resendOTP: "/api/rest/register/resendotpcode/registerEmail",
  resendLoginOTP: "/api/rest/resend_login_otp",
  resetPasswordAction: "/api/rest/register/passwordreset",
  verificationStatus: "/api/rest/customer-verification",
  checkoutCheck: "/api/rest/customer-verification-checkout",
  brands: "/api/rest/manufacturers",
  datatransFailMessage: "/api/rest/datatrans-fail-message",
  headerMenu: "/api/rest/menu",
  xNotice: "/api/rest/xnotice",
  special: "/api/rest/specials",
  giftVoucher: "/api/rest/gift/voucher",
  swapGiftVoucher: "/api/rest/gift/swap_products",

  datatransInit: "/api/rest/datatrans-init",
  datatransConfirmSuccess: "/api/rest/datatrans-confirm-success",

  homepageMeta: "/api/rest/metadata",
  cartQuantity: "/api/rest/cart_quantity",

  giftMeta: "/api/rest/gift/voucher_meta",
  giftClaim: "/api/rest/gift/gift_claim",
  giftSwap: "/api/rest/gift/gift_swap",
  giftThanks: "/api/rest/gift/gift_thank_you",
  revalidatePaths: "/api/rest/revalidate-paths",
  tfa: "/api/rest/tfa",
  verifyRecovery: "/api/rest/tfa/recovery",
  fetchCode: "/api/rest/tfa/fetch",
  registerGuest: "/api/rest/register-guest",
  notificationsPoll: "/api/rest/notifications/poll",
  notifications: "/api/rest/notifications/all",
  notificationsMarkRead: "/api/rest/notifications/mark-read",
  notificationsCategories: "/api/rest/notifications/categories",
  notificationsDelete: "/api/rest/notifications/delete",
  notificationsArchive: "/api/rest/notifications/archive",
  notificationsSubscribe: "/api/rest/notifications/subscribe",
};

export const baseUrl = process.env.NEXT_PUBLIC_BASE_URL;
export const innerBaseUrl = process.env.BASE_URL!;
